import { useEffect } from 'react';

import { EPageSection } from '@/lib/enums';

export function useLockBody(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return;

    const originalBodyOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;
    const originalPosition = document.body.style.position;
    const originalTop = document.body.style.top;
    const originalLeft = document.body.style.left;
    const originalWidth = document.body.style.width;

    const scrollContainer = document.querySelector<HTMLElement>(
      `[data-page-section="${EPageSection.CONTENT}"]`
    );
    const originalContainerOverflow = scrollContainer?.style.overflow;

    const scrollY = window.scrollY;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    // iOS Safari requires position: fixed to truly lock scrolling
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.width = '100%';

    if (scrollContainer) {
      scrollContainer.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = originalBodyOverflow;
      document.documentElement.style.overflow = originalHtmlOverflow;
      document.body.style.position = originalPosition;
      document.body.style.top = originalTop;
      document.body.style.left = originalLeft;
      document.body.style.width = originalWidth;
      if (scrollContainer) {
        scrollContainer.style.overflow = originalContainerOverflow ?? '';
      }
      window.scrollTo(0, scrollY);
    };
  }, [isLocked]);
}
